<script>
import ConfirmDialog from '@/components/dialog/ConfirmDialog'

export default {
  props: {
    change: {
      type: Number,
      default: 0
    },
    header: {
      type: String,
      default: 'พิมพ์ใบเสร็จ'
    },

    changeHeader: {
      type: String,
      default: 'เงินทอน'
    }
  },

  data() {
    return {
      visible: false
    }
  },

  mounted() {
    this.visible = true
  },

  methods: {
    handleClose() {
      this.$emit('close')
      this.visible = false
    },

    handleClosed() {
      this.$destroy()
    },

    handleTaxPrintSelect(value) {
      this.$emit('action', value)
      this.visible = false
    },

    handleCloseButtonClick() {
      this.visible = false
    }
  },

  render() {
    const renderHeader = () => (
      <div
        style={{
          margin: '0.5rem 0',
          fontWeight: 'bold',
          fontSize: '20px',
          color: '#030202'
        }}
      >
        รับชำระเงิน
      </div>
    )

    const renderAlertBox = () => (
      <div
        style={{
          border: '1px solid #979797',
          padding: '1rem',
          fontSize: '1.5rem',
          fontWeight: 'bold'
        }}
      >
        <i
          class="el-icon-check"
          style={{
            fontSize: '1.5em',
            padding: '8px',
            marginBottom: '0.5rem',
            color: '#fff',
            backgroundColor: '#46e26f',
            borderRadius: '50%'
          }}
        />
        <div>การชำระเงินเสร็จสมบูรณ์</div>
      </div>
    )

    const renderChange = () => (
      <div style={{ marginTop: '1rem' }}>
        <div style={{ marginBottom: '0.5rem' }}>{this.changeHeader}</div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div
            style={{
              padding: '1rem',
              border: '1px solid #979797',
              fontSize: '1.5rem',
              fontWeight: 'bold'
            }}
          >
            {this.change.toLocaleString('th-TH', {
              style: 'currency',
              currency: 'THB'
            })}
          </div>
        </div>
      </div>
    )

    const renderFooterBody = () => (
      <div style={{ borderTop: '1px solid #979797', padding: '1rem 0' }}>
        <div class={this.$style.lbl}>{this.header}</div>
        <el-button
          class={this.$style.button}
          onClick={() => {
            this.handleTaxPrintSelect('slip')
          }}
        >
          <div
            class={this.$style.icon}
            style={{ width: '1em', height: '1.5em' }}
          />
          Slip
        </el-button>
      </div>
    )

    const renderFooterFooter = () => (
      <div>
        <el-row>
          <el-button
            style={{ width: '100%' }}
            onClick={this.handleCloseButtonClick}
          >
            ปิด
          </el-button>
        </el-row>
      </div>
    )

    return (
      <ConfirmDialog
        visible={this.visible}
        onClose={this.handleClose}
        onClosed={this.handleClosed}
      >
        <template slot="header">{renderHeader()}</template>

        <template slot="content">
          {renderAlertBox()}
          {renderChange()}
        </template>

        <template slot="footer">
          <div style={{ width: '100%' }}>
            {renderFooterBody()}
            {renderFooterFooter()}
          </div>
        </template>
      </ConfirmDialog>
    )
  }
}
</script>

<style lang="scss" module>
.lbl {
  color: #5b9f11;
  margin-bottom: 0.5em;
  font-weight: bold;
}

.button {
  display: block;
  width: 100%;
  background-color: #d0021b;
  color: #fff;
  border-color: #d0021b !important;
  font-weight: bold;

  &:hover,
  &:focus {
    background-color: darken(#d0021b, 5%);
    color: lighten(#fff, 50%);
  }

  &:active {
    background-color: darken(#d0021b, 50%);
    color: darken(#fff, 5%);
  }
}

.icon {
  display: inline-block;
  margin-right: 0.5em;
  border: 2px solid #fff;
  vertical-align: middle;
  transition: ease-out all 125ms;

  .button:hover &,
  .button:focus & {
    border-color: lighten(#fff, 50%);
  }

  .button:active & {
    border-color: darken(#d0021b, 5%);
  }
}
</style>
